/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';

export const useInfiniteScroll = ({ loading, onLoadMore, hasNextPage }) => {
  useEffect(() => {
    const handleScroll = () => {
      const isAtBottomOfPage = ((window.innerHeight + window.scrollY) >= document.body.offsetHeight);

      if (isAtBottomOfPage && hasNextPage) {
        onLoadMore();
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [loading]);
};

export const useScrollReset = (pageIdentifier) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pageIdentifier]);
};
